import React, { useRef, useState, useEffect } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".autofitIFrame-module_iframe__2uonC {\n  width: 100%;\n  border: none !important;\n  overflow: hidden;\n  min-height: 250px; }\n";
var styles = {"iframe":"autofitIFrame-module_iframe__2uonC"};
styleInject(css);

function AutofitIFrame(props) {
    var iframeElement = useRef(null);
    var _a = useState(250), iframeHeight = _a[0], setiFrameHeight = _a[1];
    var datawrapperHeightListener = function (event) {
        if (event.origin.includes('datawrapper.dwcdn.net') &&
            typeof event.data === 'object' &&
            'datawrapper-height' in event.data) {
            var _a = Object.entries(event.data['datawrapper-height'])[0], id = _a[0], height = _a[1];
            if (props.src && props.src.includes(id)) {
                setiFrameHeight(height);
            }
        }
    };
    useEffect(function () {
        window.addEventListener('message', datawrapperHeightListener);
        return function () {
            window.removeEventListener('message', datawrapperHeightListener);
        };
    }, []);
    return (React.createElement("iframe", __assign({ className: styles.iframe, ref: iframeElement, allowTransparency: true, scrolling: 'no', style: { minHeight: iframeHeight + "px" } }, props)));
}

export { AutofitIFrame };
//# sourceMappingURL=index.js.map
